<template>
  <v-container fluid fill-height>
    <v-layout
      justify-center
      align-center
    >
      <v-flex xs12 md5>
        <spinner v-if="dataLoading === true" line-fg-color="#28AFAF" size="large"></spinner>
        <v-card class="elevation-1" v-else>
          <v-toolbar color="primary">
              <v-btn icon class="white--text" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text">Insurance Policy <br> {{ insurancePolicy.uuid }} <span v-if="insurancePolicy.cancelled === '1'"> - Canceled</span></v-toolbar-title>
          </v-toolbar>
          <v-container fluid>
              <v-layout row wrap align-center>
                <table border="1">
                  <tbody>
                    <tr>
                      <th>Plan</th>
                      <td>{{  insurancePlanName(insurancePolicy.insurance_plan_id) }}</td>
                    </tr>
                    <tr>
                      <th>Insurance Type</th>
                      <td>{{ insurancePolicy.insurance_type }}</td>
                    </tr>
                    <tr>
                      <th>Country of residence</th>
                      <td>{{ insurancePolicy.country_residence }}</td>
                    </tr>
                    <tr>
                      <th>Destination country</th>
                      <td>{{ insurancePolicy.country_destination }}</td>
                    </tr>
                    <tr>
                      <th>Date from</th>
                      <td>{{ insurancePolicy.duration_from }}</td>
                    </tr>
                    <tr>
                      <th>Date to</th>
                      <td>{{ insurancePolicy.duration_to }}</td>
                    </tr>
                    <tr>
                      <th>Days total</th>
                      <td>{{ duration }} days</td>
                    </tr>
                    <tr>
                      <th>Cost</th>
                      <td>$ {{ insurancePolicy.amount }}</td>
                    </tr>
                  </tbody>
                </table>
            </v-layout>
            <span v-for="(person, key) in insurancePolicy.people" v-bind:key="key" >
                <table border="1" class="pt-3 mt-3 mb-3">
                  <thead>
                    <tr>
                      <span class="headline" v-if="key === 0" > Beneficiary</span>
                      <span class="headline" v-if="insurancePolicy.total_parents > 1 && key == 1"> Spouse</span>
                      <span class="headline" v-if="insurancePolicy.total_children && (insurancePolicy.total_parents == 1 && key !== 0)"> Child {{ key }}</span>
                      <span class="headline" v-if="insurancePolicy.total_children && (insurancePolicy.total_parents == 2 && key !== 0 && key !== 1)"> Child {{ key - 1 }}</span>
                      <span class="headline" v-if="!insurancePolicy.total_children && !insurancePolicy.total_parents && key != 0"> User {{ key }}</span>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>First Name</th>
                      <td>{{ person.first_name }}</td>
                    </tr>
                    <tr>
                      <th>Middle Name</th>
                      <td>{{ person.middle_name }}</td>
                    </tr>
                    <tr>
                      <th>Last Name</th>
                      <td>{{ person.last_name }}</td>
                    </tr>
                    <tr>
                      <th>Passport Number</th>
                      <td>{{ person.passport_number }}</td>
                    </tr>
                    <tr>
                      <th>Date of birth</th>
                      <td>{{ person.date_of_birth }}</td>
                    </tr>
                    <tr>
                      <th>Gender</th>
                      <td>{{ person.gender }}</td>
                    </tr>
                    <tr v-if="person.has_existing_medical_condition === '1'">
                      <th>Pre Existing Medical Condition</th>
                      <td>Yes</td>
                    </tr>
                    <tr v-if="person.has_existing_medical_condition === '1'">
                      <th>Explanation</th>
                      <td>{{ person.existing_medical_condition }}</td>
                    </tr>
                    <tr v-if="person.has_medical_insurance_in_country_of_residence === '1'">
                      <th>Medical coverage with <br> an insurance company in {{insurancePolicy.country_residence}}</th>
                      <td>Yes</td>
                    </tr>
                    <tr v-if="person.has_medical_insurance_in_country_of_residence === '1'">
                      <th>Medical Explanation</th>
                      <td>{{ person.medical_insurance_in_country_of_residence }}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
               <span>
                   <v-layout align-center>
                    <v-flex>
                      <v-btn v-if="insurancePolicy.cancelled === '0'"
                        @click="downloadPdf(insurancePolicy.uuid)"
                        dark color="info"
                        >
                        Download PDF
                      </v-btn>
                    </v-flex>
                </v-layout>
               </span>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-alert
      :color="alert.type"
      icon="check_circle"
      style="position: fixed"
      :value="alert.status"
      transition="scale-transition"
    >
      {{ alert.message }}
    </v-alert>
  </v-container>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner";
import moment from "moment";
export default {
  components: {
    Spinner
  },
  data() {
    return {
      max25chars: v => v.length <= 25 || "Input too long!",
      search: "",
      dataLoading: true,
      e1: 0,
      policyValid: false,
      items: [],
      duration: null,
      insurancePolicy: [],
      insurancePlans: [],
      dialog: false,
      alert: {
        status: false,
        message: '',
        type: ''
      }
    };
  },
  created() {
    axios.get("/me").then(response => {
      this.items = response.data;
      this.getData();
    });
  },
  mounted() {
    axios.get("/insuranceplans").then(response => {
      this.insurancePlans = response.data.insurancePlans;
    });
  },
  methods: {
    insurancePlanName(plan_id) {
      let plan_name = '';
      this.insurancePlans.forEach(element => {
        if (element.id == plan_id) {
          plan_name = element.name
        }
      });
      return plan_name;
    },
    closeDialog() {
      this.dialog = !this.dialog;
    },
    alerting(){
      this.alert.status = !this.alert.status;
      setTimeout(() => {
            this.alert.status = !this.alert.status;
        }, 2500);
    },
    goBack(){
      this.$router.go(-1);
    },
    getData() {
      axios.get('/policies/' + this.$route.params.id)
      .then(response => {
        this.insurancePolicy = response.data.policies;
        this.dataLoading = false
        this.duration = this.policyDuration(this.insurancePolicy.duration_from, this.insurancePolicy.duration_to)
    });
    },
    downloadPdf(uuid){
        axios
        .get('/policies/' + uuid + '/pdf',  {responseType: 'blob'})
        .then(response => {
           let newBlob = new Blob([response.data], { type:   'application/pdf' } )
           if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob, uuid + ".pdf");
              return;
            }
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.href = data;
            link.download= uuid + ".pdf";
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              window.URL.revokeObjectURL(data);
            }, 100);
        })
        .catch(error => {
        })
    },
    policyDuration(start, finish) {
      const beg = moment(start);
      const end = moment(finish);
      const result = end.diff(beg, "days");
      return result;
    },
    policyValidation(start) {
        const exp = moment(start);
        const now = moment();
        const diffDuration = moment.duration(exp.diff(now));
        if (diffDuration.minutes() > 0){
            return true
        }
    }
  }
};
</script>

<style scoped>
.table {
  background: #e7e7e8;
  width: auto;
  table-layout: fixed
}

.table th {
  font-weight: 400;
  padding-right: 30px !important;
  background: none
}

.table td {
  font-weight: 700;
  min-width: 200px;
}

.table>thead>tr>th,
.table>tbody>tr>th,
.table>tfoot>tr>th,
.table>thead>tr>td,
.table>tbody>tr>td,
.table>tfoot>tr>td {
  border-top: none;
  padding: 5px 10px
}

.table,
.table tr+tr {
  border: none
}

.table .empty-cell {
  height: 30px
}

.table tr:nth-child(even) {
  background: #d1d2d4
}


table th {
  white-space: nowrap;
  background: #e7e7e8
}

table th,
table td {
  padding: 12px 15px;
  text-align: left
}

table tr+tr {
  border-top: 1px solid #eee
}
</style>



// WEBPACK FOOTER //
// src/components/agency/Policy/Issued/IssuedShow.vue